import { useSyncExternalStore } from 'react';
import { StencilRouteTransitionLoading } from './stencil-route-transition-loading.component';
import { STENCIL_ROUTE_LOADER_DELAY_MS } from './stencil-route-transition.constants';
import {
    getStencilRouteTransitionSnapshot,
    getServerStencilRouteTransitionSnapshot,
    markStencilRouteTransitionVisible,
    subscribeToStencilRouteTransition,
} from './stencil-route-transition.store';
import { useStencilRouteTransitionListener } from './use-stencil-route-transition-listener.hook';

interface StencilRouteTransitionContainerProps extends React.PropsWithChildren {
    backgroundColor: string;
    contentSelector?: string;
    leftOffset?: string;
    topOffset?: string;
}

export const StencilRouteTransitionContainer: React.FC<StencilRouteTransitionContainerProps> = ({
    backgroundColor,
    children,
    contentSelector,
    leftOffset,
    topOffset,
}) => {
    useStencilRouteTransitionListener(contentSelector);
    const active = useSyncExternalStore(
        subscribeToStencilRouteTransition,
        getStencilRouteTransitionSnapshot,
        getServerStencilRouteTransitionSnapshot
    );

    return (
        <StencilRouteTransitionLoading
            active={active}
            backgroundColor={backgroundColor}
            delayMs={STENCIL_ROUTE_LOADER_DELAY_MS}
            leftOffset={leftOffset}
            topOffset={topOffset}
            onVisible={markStencilRouteTransitionVisible}
        >
            {children}
        </StencilRouteTransitionLoading>
    );
};
